import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const CertificateSelection = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedTaluka, setSelectedTaluka] = useState('');
  const [selectedVillage, setSelectedVillage] = useState('');
  const [selectedCertificate, setSelectedCertificate] = useState('');

  // Structured data for districts, talukas, and villages
  const districtData = {
    'सांगली': {
      en: 'Sangli',
      talukas: {
        'जि.प. सांगली': ['सांगली', 'कवठे महांकाळ', 'मिरज', 'पलुस'],
        'कवठे महांकाळ': ['कवठे महांकाळ', 'शिराळ', 'आटपाडी', 'जावळी'],
        'मिरज': ['मिरज', 'खानापूर', 'उपळा', 'कुडाळ'],
        'पलुस': ['पलुस', 'वाळवा', 'शिराळा', 'तासगाव'],
        'वाळवा': ['वाळवा', 'शिराळा', 'भुदरगड', 'खानापूर'],
        'शिराळा': ['शिराळा', 'आटपाडी', 'भुदरगड', 'कटकरवाडी'],
        'तासगाव': ['तासगाव', 'येवला', 'सोनारी', 'विटा'],
        'जत': ['जत', 'कराड', 'कडेगाव', 'खानापूर']
      }
    },
    'सातारा': {
      en: 'Satara',
      talukas: {
        'सातारा': ['सातारा', 'कोरेगाव', 'जावळी', 'खंडाळा'],
        'कराड': ['कराड', 'पाटण', 'खटाव', 'वडूज'],
        'फलटण': ['फलटण', 'बारामती', 'खंडाळा', 'मावळ'],
        'महाबळेश्वर': ['महाबळेश्वर', 'माण', 'खटाव', 'फलटण'],
        'जावळी': ['जावळी', 'खंडाळा', 'माण', 'कऱ्हाड'],
        'कोरेगाव': ['कोरेगाव', 'सातारा', 'पाटण', 'वडूज']
      }
    },
    'कोल्हापूर': {
      en: 'Kolhapur',
      talukas: {
        'कोल्हापूर': ['कोल्हापूर', 'पन्हाळा', 'गगनबावडा', 'शिरोळ'],
        'पन्हाळा': ['पन्हाळा', 'शिरोळ', 'गगनबावडा', 'आजरा'],
        'शिरोळ': ['शिरोळ', 'पन्हाळा', 'कागल', 'शाहूवाडी'],
        'गगनबावडा': ['गगनबावडा', 'शिरोळ', 'पन्हाळा', 'आजरा'],
        'चंदगड': ['चंदगड', 'कारवीर', 'भुदरगड', 'शिरोळ'],
        'कारवीर': ['कारवीर', 'चंदगड', 'भुदरगड', 'कोल्हापूर'],
        'राधानगरी': ['राधानगरी', 'शिरोळ', 'कागल', 'आजरा'],
        'आजरा': ['आजरा', 'पन्हाळा', 'गगनबावडा', 'राधानगरी']
      }
    },
    'पुणे': {
      en: 'Pune',
      talukas: {
        'पुणे': ['पुणे', 'हवेली', 'पिंपरी-चिंचवड', 'लोणावळा'],
        'हवेली': ['हवेली', 'पुणे', 'उरुळी कांचन', 'जुन्नर'],
        'पिंपरी-चिंचवड': ['पिंपरी-चिंचवड', 'पुणे', 'हवेली', 'इंदापूर'],
        'लोणावळा': ['लोणावळा', 'जुन्नर', 'उरुळी कांचन', 'शिरूर'],
        'जुन्नर': ['जुन्नर', 'लोणावळा', 'उरुळी कांचन', 'शिरूर'],
        'शिरूर': ['शिरूर', 'जुन्नर', 'परवडी', 'बारामती'],
        'परवडी': ['परवडी', 'शिरूर', 'बारामती', 'वेल्हे'],
        'बारामती': ['बारामती', 'परवडी', 'शिरूर', 'इंदापूर']
      }
    },
    'सोलापूर': {
      en: 'Solapur',
      talukas: {
        'सोलापूर': ['सोलापूर', 'उत्तर सोलापूर', 'दक्षिण सोलापूर', 'पंढरपूर'],
        'पंढरपूर': ['पंढरपूर', 'सांगोला', 'मोहोळ', 'अक्कलकोट'],
        'सांगोला': ['सांगोला', 'पंढरपूर', 'मोहोळ', 'अक्कलकोट'],
        'मोहोळ': ['मोहोळ', 'सांगोला', 'पंढरपूर', 'बार्शी'],
        'अक्कलकोट': ['अक्कलकोट', 'सांगोला', 'मोहोळ', 'पंढरपूर'],
        'बार्शी': ['बार्शी', 'मोहोळ', 'सांगोला', 'करमाळा'],
        'करमाळा': ['करमाळा', 'बार्शी', 'मोहोळ', 'सोलापूर'],
        'माढा': ['माढा', 'करमाळा', 'बार्शी', 'सोलापूर']
      }
    }
  };

  // Get available talukas based on selected district
  const getAvailableTalukas = () => {
    if (!selectedDistrict) return [];
    return Object.keys(districtData[selectedDistrict]?.talukas || {});
  };

  // Get available villages based on selected district and taluka
  const getAvailableVillages = () => {
    if (!selectedDistrict || !selectedTaluka) return [];
    return districtData[selectedDistrict]?.talukas[selectedTaluka] || [];
  };

  // Reset dependent fields when parent selection changes
  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
    setSelectedTaluka('');
    setSelectedVillage('');
  };

  const handleTalukaChange = (e) => {
    setSelectedTaluka(e.target.value);
    setSelectedVillage('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedTaluka && selectedDistrict && selectedVillage) {
      // Store selections in localStorage for later use
      localStorage.setItem('selectedTaluka', selectedTaluka);
      localStorage.setItem('selectedDistrict', selectedDistrict);
      localStorage.setItem('selectedVillage', selectedVillage);
      
      // Navigate to appropriate page based on certificate type
      switch (selectedCertificate) {
        case 'जन्म प्रमाणपत्र':
          navigate('/Birthcertificate');
          break;
        case 'मृत्यू प्रमाणपत्र':
          navigate('/deathcertificate');
          break;
        case 'विवाह प्रमाणपत्र':
          navigate('/Requestmarriage');
          break;
        case 'दारिद्र्य रेषेखालील प्रमाणपत्र':
          navigate('/Properstandard');
          break;
        case 'ग्रामपंचायत येणेबाकी नसल्याचा दाखला':
          navigate('/Demancertificate');
          break;
        case 'नमुना न.८-अ उतारा':
          navigate('/certificate-selection'); // Add route later if needed
          break;
        case 'निराधार असल्याचा दाखला':
          navigate('/Certificatedestitute'); // Add route later if needed
          break;
        default:
          navigate('/deathcertificate');
      }
    } else {
      alert(language === 'marathi' ? 'कृपया तालुका, जिल्हा आणि गाव निवडा' : 'Please select Taluka, District and Village');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-center text-blue-900 mb-8">
              {language === 'marathi' ? 'प्रमाणपत्रासाठी नोंदणी' : 'Registration for Certificate'}
            </h2>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Certificate Type Selection */}
              <div>
                <label className="block text-lg font-semibold text-gray-700 mb-3">
                  {language === 'marathi' ? 'प्रमाणपत्राचा प्रकार निवडा *' : 'Select Certificate Type *'}
                </label>
                <select
                  value={selectedCertificate}
                  onChange={(e) => setSelectedCertificate(e.target.value)}
                  className="w-full px-3 sm:px-4 py-3 border-2 border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 text-base sm:text-lg max-w-full truncate"
                  required
                >
                  <option value="">{language === 'marathi' ? '-- प्रमाणपत्र निवडा --' : '-- Select Certificate --'}</option>
                  <option value="जन्म प्रमाणपत्र">{language === 'marathi' ? 'जन्म प्रमाणपत्र' : 'Birth Certificate'}</option>
                  <option value="मृत्यू प्रमाणपत्र">{language === 'marathi' ? 'मृत्यू प्रमाणपत्र' : 'Death Certificate'}</option>
                  <option value="विवाह प्रमाणपत्र">{language === 'marathi' ? 'विवाह प्रमाणपत्र' : 'Marriage Certificate'}</option>
                  <option value="दारिद्र्य रेषेखालील प्रमाणपत्र">{language === 'marathi' ? 'BPL प्रमाणपत्र' : 'BPL Certificate'}</option>
                  <option value="ग्रामपंचायत येणेबाकी नसल्याचा दाखला">{language === 'marathi' ? 'येणेबाकी नसल्याचा दाखला' : 'No Dues Certificate'}</option>
                  <option value="नमुना न.८-अ उतारा">{language === 'marathi' ? 'नमुना न.८-अ उतारा' : 'Form No. 8-A Extract'}</option>
                  <option value="निराधार असल्याचा दाखला">{language === 'marathi' ? 'निराधार असल्याचा दाखला' : 'Destitute Certificate'}</option>
                </select>
              </div>

              {/* District Selection */}
              <div>
                <label className="block text-lg font-semibold text-gray-700 mb-3">
                  {language === 'marathi' ? 'जिल्हा निवडा *' : 'Select District *'}
                </label>
                <select
                  value={selectedDistrict}
                  onChange={handleDistrictChange}
                  className="w-full px-3 sm:px-4 py-3 border-2 border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 text-base sm:text-lg max-w-full truncate"
                  required
                >
                  <option value="">{language === 'marathi' ? '-- जिल्हा निवडा --' : '-- Select District --'}</option>
                  {Object.keys(districtData).map((district) => (
                    <option key={district} value={district}>
                      {language === 'marathi' ? district : districtData[district].en}
                    </option>
                  ))}
                </select>
              </div>

              {/* Taluka Selection */}
              <div>
                <label className="block text-lg font-semibold text-gray-700 mb-3">
                  {language === 'marathi' ? 'तालुका निवडा *' : 'Select Taluka *'}
                </label>
                <select
                  value={selectedTaluka}
                  onChange={handleTalukaChange}
                  className="w-full px-3 sm:px-4 py-3 border-2 border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 text-base sm:text-lg max-w-full truncate"
                  required
                  disabled={!selectedDistrict}
                >
                  <option value="">{language === 'marathi' ? '-- तालुका निवडा --' : '-- Select Taluka --'}</option>
                  {getAvailableTalukas().map((taluka) => (
                    <option key={taluka} value={taluka}>
                      {taluka}
                    </option>
                  ))}
                </select>
              </div>

              {/* Village Selection */}
              <div>
                <label className="block text-lg font-semibold text-gray-700 mb-3">
                  {language === 'marathi' ? 'गाव निवडा *' : 'Select Village *'}
                </label>
                <select
                  value={selectedVillage}
                  onChange={(e) => setSelectedVillage(e.target.value)}
                  className="w-full px-3 sm:px-4 py-3 border-2 border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 text-base sm:text-lg max-w-full truncate"
                  required
                  disabled={!selectedTaluka}
                >
                  <option value="">{language === 'marathi' ? '-- गाव निवडा --' : '-- Select Village --'}</option>
                  {getAvailableVillages().map((village) => (
                    <option key={village} value={village}>
                      {village}
                    </option>
                  ))}
                </select>
              </div>

              {/* Submit Button */}
              <div className="text-center pt-4">
                <button
                  type="submit"
                  className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  {language === 'marathi' ? 'पुढे जा →' : 'Proceed →'}
                </button>
              </div>
            </form>

            {/* Back Button */}
            <div className="text-center mt-6">
              <button
                onClick={() => navigate('/')}
                className="text-blue-600 hover:text-blue-800 font-medium text-lg"
              >
                {language === 'marathi' ? '← मुखपृष्ठावर परत जा' : '← Back to Home Page'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateSelection;
